<template>
    <div
        class="onboarding-box-select-container"
        :class="{ selected, type, disabled }"
        role="radio"
        :aria-checked="selected ? 'true' : 'false'"
        :aria-disabled="disabled ? 'true' : 'false'"
        :tabindex="disabled ? -1 : 0"
        @click="handleSelect"
        @keydown.enter.prevent="handleSelect"
        @keydown.space.prevent="handleSelect"
    >
        <div v-if="selected" class="check-box">
            <Icon icon-name="check" />
        </div>
        <slot name="content"></slot>
    </div>
</template>

<script>
    import Icon from "@/scripts/common/Icon.vue";

    export default {
        name: "OnboardingBoxSelect",
        components: {
            Icon
        },
        props: {
            disabled: {
                type: Boolean,
                default: false
            },
            selected: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: ""
            }
        },
        emits:['handleClick'],
        methods: {
            handleSelect() {
                if (this.disabled) return;
                this.$emit('handleClick');
            }
        }

    }
</script>

<style scoped lang="scss">
    .onboarding-box-select-container {
        width: 174px;
        background-color: var(--asphalt15);
        border-radius: 8px;
        flex: 1 1 calc(50% - 8px);
        padding: 16px 20px;
        position:relative;

        .check-box {
            position:absolute;
            width: 24px;
            height: 24px;
            background-color: var(--asphalt100);
            right: -8px;
            top: -8px;
            border-radius: 99px;
            padding: 2px;
            display: flex;
            justify-content: center;
            align-items: center;

            svg {
                color: var(--asphalt10);
                width: 18px;
                height: 18px;
            }
        }

        &.color {
            padding: 20px;
        }

        &.font {
            padding: 16px 20px;
        }

        &:hover {
            cursor: pointer;
            background-color: var(--asphalt20);
        }

        &:focus-visible {
            outline: 2px solid var(--asphalt100);
            outline-offset: 2px;
        }

        &.disabled {
            cursor: not-allowed;
            opacity: 0.6;
        }

        &.disabled:hover {
            background-color: var(--asphalt15);
        }

        &.selected {
            background-color: var(--asphalt20);
        }
    }
</style>